<eui-toolbar-item>
    <ng-content select="eui-notifications"></ng-content>
</eui-toolbar-item>
